import React from "react";
import { sliderPortrait } from "../../data/films";
import { AI_FILTER, defeatedTells } from "../../data/notell";
export function DefeatedTells() {
  return <div data-id="element-254" data-mp="yfh00fjyye5a">
      <h3 className="font-serif text-[26px] leading-none tracking-[-0.01em] text-white md:text-[32px]" data-id="element-255" data-mp="12f7xf2403sis">
        The tells. <em className="italic text-signal" data-id="element-256" data-mp="17e2i69lj3r5j">Defeated.</em>
      </h3>
      <ul className="mt-8 grid grid-cols-2 gap-x-3 gap-y-6 sm:grid-cols-3 lg:grid-cols-6 lg:gap-x-4" data-id="element-257" data-mp="17c81x8l7cn7s">
        {defeatedTells.map(tell => <li key={tell.word} data-id="element-258" data-mp="eovi366feti6">
            <div className="relative aspect-square overflow-hidden border border-hairline bg-card" data-id="element-259" data-mp="eq6iqx4krl52">
              <div className="absolute inset-0" role="img" aria-label={`Close-up of ${tell.word.toLowerCase()} on the typical AI version`} style={{
            backgroundImage: `url(${sliderPortrait.src})`,
            backgroundSize: `${tell.zoom}% auto`,
            backgroundPosition: `${tell.x}% ${tell.y}%`,
            filter: AI_FILTER
          }} data-id="element-260" data-mp="jn6tvmga7e31" />
              <div className="absolute inset-0 bg-black/35" aria-hidden="true" data-id="element-261" data-mp="2bd232qioe8i7" />
              <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-id="element-262" data-mp="26mbul4eydpja">
                <line x1="6" y1="94" x2="94" y2="6" stroke="#FF4950" strokeWidth="2" vectorEffect="non-scaling-stroke" data-id="element-263" data-mp="21mpk32qiene6" />
              </svg>
              <span className="absolute left-2 top-2 bg-signal px-1.5 py-0.5 font-mono text-[9px] tracking-[0.14em] text-ink" data-id="element-264" data-mp="1wm1jpqge4u7a">
                DEFEATED
              </span>
            </div>
            <p className="mt-3 font-serif text-[18px] leading-tight text-foot line-through decoration-signal decoration-2 md:text-[20px]" data-id="element-265" data-mp="1nptxs8l8yzg6">
              {tell.word}
            </p>
          </li>)}
      </ul>
    </div>;
}